import { useEffect, useState } from "react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/** v3 toasts: white, hairline, 16px radius; bottom-centre on phones, bottom-end on desktop. */
const Toaster = ({ dir, ...props }: ToasterProps) => {
  const [wide, setWide] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const on = () => setWide(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  const rtl = dir !== "ltr";
  return (
    <Sonner
      className="toaster group"
      dir={dir}
      position={wide ? (rtl ? "bottom-left" : "bottom-right") : "bottom-center"}
      toastOptions={{
        classNames: {
          toast:
            "group toast w-full max-w-[24rem] !rounded-ds-md !border !border-hairline-default !bg-surface !text-brown-700 !shadow-md font-body",
          title: "font-display !text-[15px] !font-bold",
          description: "!text-[14px] !text-brown-500",
          success: "[&_[data-icon]]:text-green-800",
          error: "[&_[data-icon]]:text-coral-700",
          actionButton: "!rounded-ds-pill !bg-amber-500 !text-brown-700 !font-bold",
          cancelButton: "!rounded-ds-pill !bg-cream-100 !text-brown-700",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
